import React, { useState, useEffect, useRef } from 'react';
import FoundationsSelect from "../../GenericComponents/select"
import { FoundationsInput } from '../../GenericComponents/input';
import { FoundationsButton } from '../../GenericComponents/button';
import { appSettingsType } from '../../Types/appSettings';
import { getBaseUrl } from '../../Utils';
import Approve from './Approve';
import Delete from './Delete';
import {
  useProxyUserMutation
} from '../../Redux/UserSettings/userSettingsSlice';
 import ChangePassword from './ChangePassword'
import Reject from './Reject';
import Edit from './Edit';
import { useAttributeMutation, useDeleteMutation, useForceSignOutMutation, useGetRolesMutation, useRejectMutation, useSavedAttributesMutation, useUsersbyStatusMutation } from '../../Redux/Admin_Tasks/userAccountSlice';
import { getAppSettings, getCurrentUserData, RootState, setAppRedirectURL, setAppWorkflowState } from '../../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { checkType1OrHasPrivilege, redirectHome } from '../../GlobalMethods';
import { appWorkflowStates } from '../../Types/appWorkflowStates';
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster';
import { useTitleContext } from "../../Hooks/useTitleContext"
import { useApplyHighlight } from '../../GenericComponents/useApplyHighlight';
import { FoundationsConstants } from '../../FoundationsConstants';

const ManageUserAccounts: React.FC = () => {
  const [userStatus, setUserStatus] = useState<string>('Registered');
  const [userRole, setUserRole] = useState<string | undefined>(undefined);  // Correctly typed
  const [userLocation, setUserLocation] = useState<string>('');
  const [locations, setLocations] = useState<any[]>([]); 
  const [userSearch, setUserSearch] = useState<string>('EmailAddress');
  const [searchName, setSearchName] = useState<string>(''); 
  const [localSearchName, setLocalSearchName] = useState("");
  const [appSettings, setAppSettings] = useState({} as appSettingsType);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editdialogOpen, setEditDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState<{ userId?: string | null; approveMode?: string | null }>({});
  const [isProxyModeAllowed, setisProxyModeAllowed] = useState(false)
  const [isManageUsersAllowed,setisManageUsersAllowed]=useState(true)
  const [Error, setError] = useState('')
  const [forceUpdate, setForceUpdate] = useState(0); // State to trigger re-render
  
  const [fetchUsersByStatus, { data: dataUser, error: usersError, isLoading: usersLoading }] = useUsersbyStatusMutation();
  const [fetchRoles, { data: roles, error: rolesError, isLoading: rolesLoading }] = useGetRolesMutation();
  const[fetchSavedAttributes,{data: saveAttribute, error: saveAttributeError, isLoading: saveAttributeLoading}]=useSavedAttributesMutation()
  const[fetchUserAttribute,{data:userAttribute,error:userAttributeError, isLoading: userAttributeLoading}]=useAttributeMutation();
  const [fetchDelete, { data: deleteResponse, error: deleteError, isLoading: isDeleting }] = useDeleteMutation();
  const [ProxyUser, { isLoading: proxyingUserLoading },] = useProxyUserMutation()
  const [ForceSingout,{data: ForceSingoutResponse, error: ForceSingoutError, isLoading: ForceSingoutLoading }]= useForceSignOutMutation();
  const [fetchReject,{ data: rejectResponse, error: rejectError, isLoading: isRejecting }]= useRejectMutation();
  const [previousDataUser, setPreviousDataUser] = useState<any>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // Track delete dialog visibility
  const [deleteUserId, setDeleteUserId] = useState<string | null>(null); // Track user ID to delete
  const [deleteComment, setDeleteComment] = useState<string>('');
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectUserId, setRejectUserId] = useState<string | null>(null); // Track user ID to delete
  const [rejectComment, setRejectComment] = useState<string>('');
  const [changePasswordDialogOpen, setchangePasswordDialogOpen] = useState(false); // Track delete dialog visibility
  const [changePasswordUserId, setchangePasswordUserId]=useState<string|null>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [approveComment, setApproveComment] = useState<string>('');
  const dispatch = useDispatch()
  const {applyHighlight, highlightClass } = useApplyHighlight(FoundationsConstants.APPLY_HIGHLIGHT_DURATION);

  const { setTitle } = useTitleContext();
  // Update the function to return undefined when role is not found
const findRoleIdByName = (roleName: string): string | undefined => {
  const role = roles?.userRolesData.find((r: { Name: string; Id: number }) => r.Name === roleName);
  return role ? role.Id.toString() : undefined;  
};
const appSettingsFromStore: any = useSelector(
  (state: RootState) => { return getAppSettings(state) || {} }
)

  const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )


// Function to fetch users based on current filters
const fetchUsers = () => {
  const roleId = userRole ? findRoleIdByName(userRole) : undefined;
  
  // Create search params object
  const searchParams: any = {
    userStatus,
    userRole: roleId,
    userLocation: userLocation || "-1",
  };
    searchParams.userSearchField = userSearch;
    searchParams.userSearch = searchName || '';
  fetchUsersByStatus(searchParams);
};

// This effect runs whenever any filter criteria changes
useEffect(() => {
  fetchUsers();
}, [userStatus, userRole, userLocation, searchName, userSearch, forceUpdate]);

useEffect(() => {
  setTitle("Manage Users");
}, []);

useEffect(() => {
  if (dataUser) {
    setPreviousDataUser(dataUser);
  }
}, [dataUser]);

// Format date time 
const formatDateTime = (dateString :any ) => {
  if (!dateString) return "-"; 
  const parsedDate = new Date(dateString.trim());
  const datePart = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(parsedDate);
  const timePart = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(parsedDate);
  return `${datePart} at ${timePart}`;
};

 // Handle status change
 const handleStatusChange = (e: { target: { value: string } }) => {
  setUserStatus(e.target.value); // Search is maintained when changing status due to useEffect dependency
};

// Search function
const handleSearch = () => {
  applyHighlight("admin_searchusers", "applyHighLight", { autoHide: false });
  setSearchName(localSearchName); // The search will be triggered by the useEffect that watches searchName
  fetchUsers();
};

 const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    if (localSearchName.trim() !== "") {
        setSearchName(localSearchName);
      handleSearch();
    }
  }
};

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  useEffect(() =>{
    fetchUserAttribute()
  },[fetchUserAttribute]);
  

  useEffect(() => {
    if (Array.isArray(appSettingsFromStore.availableLocations)) {
      const locationsArray = appSettingsFromStore.availableLocations.map((loc: any) => ({
        id: String(loc.id),
        location: loc.location,
      }));
      setLocations(locationsArray);
    }
      if (currentUserData) {
      setisProxyModeAllowed(
        (!currentUserData.proxyInfo || !currentUserData.proxyInfo.isProxyMode) &&
        checkType1OrHasPrivilege(currentUserData, 'AllowProxyUser')
      );
    }
  }, [appSettingsFromStore.availableLocations, currentUserData]);


//Approve 
const handleDialogOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
  const userIdString = event.currentTarget.getAttribute('data-userId');
  const userId = userIdString ? Number(userIdString) : null;
  const approveMode = event.currentTarget.getAttribute('data-approveMode');
  if (userId && approveMode !== undefined) {  
    fetchSavedAttributes({ userId });
    setApproveComment(''); 
    setDialogData({ 
      userId: userId.toString(), approveMode: approveMode });
    setDialogOpen(true);
  }
};

//Edit
const handleEditDialogOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
  const userIdString = event.currentTarget.getAttribute('data-userId');
  const userId = userIdString ? Number(userIdString) : null;
  const approveMode = event.currentTarget.getAttribute('data-approveMode');
  if (userId && approveMode !== undefined) {  
    fetchSavedAttributes({ userId });
    setDialogData({ 
      userId: userId.toString(), approveMode: approveMode });
      setEditDialogOpen(true);
  }
};

//Delete
const handleDeleteOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
  const userIdString = event.currentTarget.getAttribute('data-userId');
  const userId = userIdString //? String(userIdString) : null;
  if (userId) {
    setDeleteUserId(userId); // Store the userId to delete
   setDeleteComment('');   // Reset comment when opening the dialog
    setDeleteDialogOpen(true); // Open delete confirmation dialog
  }
};

//Reject
const handleRejectOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
  const userIdString = event.currentTarget.getAttribute('data-userId');
  const userId = userIdString ? String(userIdString) : null;

  if (userId) {
    setRejectUserId(userId); // Store the userId to delete
    setRejectComment('');
    setRejectDialogOpen(true); // Open delete confirmation dialog
  }
};

//ChangePassword
const changePasswordOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
  const userIdString = event.currentTarget.getAttribute('data-userId');
  const userId = userIdString ? String(userIdString) : null;

  if (userId) {
    setchangePasswordUserId(userId); // Store the userId to delete
    setchangePasswordDialogOpen(true); // Open delete confirmation dialog
  }
};

const onSuccess = () => {
  setForceUpdate(prev => prev + 1);
};

//Proxy Function
const handleProxyClick = (userId: number) => {
  if (userId === -1) {
      setError('Please select a user and try again.');
  } else {
      const proxyUser = {
          userId
      };
      ProxyUser(proxyUser)
          .unwrap().then(res =>{
                          if (res.data !== null) {   
                              dispatch(setAppRedirectURL(redirectHome(currentUserData)))
                              dispatch(setAppWorkflowState(appWorkflowStates.FORCE_REDIRECT))  
                          }
          })
          .catch(err => {
              setError("An error occurred while trying to proxy the user.");
          });
  }
};

//ForceSingout
const handleForceSignOut = async (event: React.MouseEvent<HTMLAnchorElement>) => {
  event.preventDefault();
  const userId = event.currentTarget.getAttribute('data-userId'); // Retrieve the userId from the data attribute

  if (userId) {
  try {
    const response = await ForceSingout({ userId: Number(userId) });

    if (response.data.statusCode === 201) {
      FoundationsGenericToaster('success', "UserTokens have been invalidated successfully.");
    }
  } catch (err) {
    console.error('Error in ForceSignOut:', ForceSingoutError || err);
  }
  } else {
    console.warn('No userId provided');
  }
};
  const isRolesArray = Array.isArray(roles?.userRolesData);
   
  // Dynamically render table headers based on userStatus
  const renderTableHeaders = () => {
    let headers = [
      <td key="username-email" style={{ width: '170px' }}>User Name and Email</td>,
      <td key="location" style={{ width: '170px' }}>Location</td>,
      <td key="role" style={{ width: '50px' }}>Role</td>,
    ];
    switch (userStatus) {
      case 'Registered':
        headers.push(<td key="registered-on">Registered On</td>, <td key="actions">Actions</td>);
        break;
      case 'Confirmed':
        headers.push(<td key="registered-on">Registered On</td>, <td key="confirmed-on">Confirmed On</td>, <td key="actions">Actions</td>);
        break;
      case 'Approved':
        headers.push(<td key="confirmed-on">Confirmed On</td>, <td key="approved-on">Approved On</td>, <td key="last-updated">Last Updated On</td>, <td key="actions">Actions</td>);
        break;
      case 'Rejected':
        headers.push(<td key="rejected-on">Rejected On</td>, <td key="rejected-comment">Rejected Comment</td>, <td key="actions">Actions</td>);
        break;
      case 'Deleted':
        headers.push(<td key="deleted-on">Deleted On</td>, <td key="deleted-comment">Deleted Comment</td>, <td key="actions">Actions</td>);
        break;
      default:
        headers.push(<td key="actions">Actions</td>);
        break;
    }
    return <tr className="admin-row-header">{headers}</tr>;
  };

  // Dynamically render table rows
  const renderTableRows = () => {
    const userCount = previousDataUser?.usersCount || 0;
    if (userCount > 50) {
      return (
        <tr className="admin-row-data">
          <td colSpan={100}>More than 50 users found, please narrow your search.</td>
        </tr>
      );
    } 
    if (userCount === 0) {
      return (
        <tr className="admin-row-data">
          <td colSpan={100}>No records found.</td>
        </tr>
      );
    }
  
    // Only proceed if userCount is greater than 0 and less than or equal to 50
    return previousDataUser?.usersData
      ?.filter((user: any) => {
        //Role
        const roleMatch = userRole ? user.PrimaryRole.Name === userRole : true;
        //Location
        const selectedLocationKeys = userLocation?.split(",") || [];
        // Location matching using the filterUsersByLocation logic
        let locationMatch = true;
        if (userLocation) {
          locationMatch = selectedLocationKeys.some((key: string) => {
            // Find the location object matching this key
            const locationObj = locations.find((loc) => loc.id === key);
            if (!locationObj) return false;
            const selectedLocation = locationObj.location;
            // Apply the filterUsersByLocation logic for this user and selected location
            if (typeof user.Location === 'string') {
              return user.Location === selectedLocation || user.Location.includes(selectedLocation);
            }
            if (Array.isArray(user.Location)) {
              return user.Location.includes(selectedLocation);
            }
            const locationArray = user.Location.split(/\s+/).map((loc: any) => loc.trim());
            return locationArray.includes(selectedLocation) || user.Location.includes(selectedLocation);
          });
        }

        const searchMatch =
        !searchName || // If no search name is provided, show all users
          (userSearch == 'EmailAddress' && user.EmailAddress.toLowerCase().includes(searchName.toLowerCase())) ||
          (userSearch == 'FirstName' && user.FirstName.toLowerCase().includes(searchName.toLowerCase())) ||
          (userSearch == 'LastName' && user.LastName.toLowerCase().includes(searchName.toLowerCase())) ||
          (userSearch == 'DisplayName' && user.FullName.toLowerCase().includes(searchName.toLowerCase()));

        // Return true only if both role and location match
        return roleMatch && locationMatch && searchMatch;
     
      }).map((user: any, index: number) => (
      <tr 
        key={user.Id} 
        className={index % 2 === 0 ? 'admin-row-data' : 'admin-alt-row-data'} 
      >
        <td>
          <span className="large">{user.FullName}</span><br />
          <span className="smaller sub-info">{user.EmailAddress}</span>
        </td>
         <td><span className="large">{user.Location}</span></td>
        
        <td><span className="large">{user.PrimaryRole?.Name}</span></td>
        
        {/* Handling rows based on user status */}
        {userStatus === 'Registered' && (
          <>
            {user.CreatedOn ? (
              <td>{formatDateTime(user.CreatedOn)}</td>
            ) : (
              <td>-</td>
            )}
            <td>
             <a href="#" data-userId={user.Id} data-approveMode='1' onClick={(e) => { e.preventDefault();  handleDialogOpen(e); }}>Approve</a> 
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} data-approveMode='0' onClick={(e) => { e.preventDefault();  handleEditDialogOpen(e); }}>Edit</a>
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} onClick={(e) => { e.preventDefault();  handleDeleteOpen(e); }}>Delete</a>
            </td>
          </>
        )}
  
        {userStatus === 'Confirmed' && (
          <>
            {user.CreatedOn ? (
              <td>{formatDateTime(user.CreatedOn)}</td>
            ) : (
              <td>-</td>
            )}
            {user.ConfirmedOn ? (
              <td>{formatDateTime(user.ConfirmedOn)}</td>
            ) : (
              <td>-</td>
            )}
            <td>
            <a href='#' data-userId={user.Id} data-approveMode='1' onClick={(e) => { e.preventDefault();  handleDialogOpen(e); }}>Approve</a>
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} onClick={(e) => { e.preventDefault();  handleRejectOpen(e); }}>Reject</a> 
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} data-approveMode='0' onClick={(e) => { e.preventDefault();  handleEditDialogOpen(e); }}>Edit</a>
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} onClick={(e) => { e.preventDefault();  handleDeleteOpen(e); }}>Delete</a>
            </td>
          </>
        )}
        {userStatus === 'Approved' && (
          <>
            {/* ConfirmedOn Check */}
            {user.ConfirmedOn ? (
                      <td>{formatDateTime(user.ConfirmedOn)}</td>
                    ) : (
                      <td>-</td>
                    )}
            {/* ApprovedOn Check */}
            {user.ApprovedOn ? (
                      <td>{formatDateTime(user.ApprovedOn)}</td>
                    ) : (
                      <td>-</td>
                    )}
            {/* LastUpdatedOn Check */}        
            {user.LastUpdatedOn ? (
                      <td>{formatDateTime(user.LastUpdatedOn)}</td>
                    ) : (
                      <td>-</td>
                    )}
            {/* Action Links */}        
            <td>
            <a href='#' data-userId={user.Id} onClick={(e) => { e.preventDefault();  changePasswordOpen(e); }}>Change Password</a> 
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} data-approveMode='0' onClick={(e) => { e.preventDefault();  handleEditDialogOpen(e); }}>Edit</a>
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} onClick={(e) => { e.preventDefault();  handleDeleteOpen(e); }}>Delete</a>
                {/* Proxy User Links */}
                {isProxyModeAllowed && user.AllowUserProxy ? (
                  <>
                    <span className="admin-menu-divider">•</span>
                    <a
                      href="#"
                      className="proxyUser"
                      data-userId={user.Id}
                      onClick={(e) => {
                        e.preventDefault();
                        handleProxyClick(user.Id); // Call the proxy click handler with the user ID
                      }}
                    >
                      Proxy User
                    </a>
                  </>
                ) : null}
              {/* Force SignOut Link */}
              {isManageUsersAllowed && (
                <>
                  <span className='admin-menu-divider'>•</span>
                  <a href='#' className='invalidateSession' data-userId={user.Id}  onClick={(e) => { e.preventDefault(); handleForceSignOut(e)}}>Force SignOut</a>
                </>
              )}
            </td>
          </>
        )}  
        {userStatus === 'Rejected' && (
          <>
            {user.RejectedOn ? (
              <td>{formatDateTime(user.PrimaryRole.RejectedOn)}</td>
            ) : (
              <td>-</td>
            )}
            <td>{user.RejectedComment || '-'}</td>
            <td>
            <a href='#' data-userId={user.Id} data-approveMode='0'onClick={(e) => { e.preventDefault();  handleEditDialogOpen(e); }}>Edit</a> 
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} onClick={(e) => { e.preventDefault();  handleDeleteOpen(e); }}>Delete</a>
            </td>
          </>
        )}
  
        {userStatus === 'Deleted' && (
          <>
            {user.DeletedOn ? (
              <td>{formatDateTime(user.DeletedOn)}</td>
            ) : (
              <td>-</td>
            )}
            <td>{user.DeletedComment || '-'}</td>
            <td>
            <a href='#'  data-userId={user.Id} data-approveMode='1' onClick={(e) => { e.preventDefault();  handleDialogOpen(e); }}>Approve</a> 
            <span className="admin-menu-divider">•</span>
            <a href='#' data-userId={user.Id} data-approveMode='0' onClick={(e) => { e.preventDefault();  handleEditDialogOpen(e); }}>Edit</a> 
            </td>
          </>
        )}
      </tr>
    ));
  };
  
  return (
    <div>
      <div className="float-right margin-top-small">
         <a id="link_backto_admin_tasks" href="#AdminTasks">&laquo;Back to Admin Tasks</a>
      </div>
      <div className="header" style={{ marginBottom: '10px' }}>Manage User Accounts</div>
      <div id="status_message" className="hide"></div>
      <div className="float-right margin-top-small">
        <span id="users_count" className="sub-info"></span>
        <span className="sub-info"></span>
      </div>
      <div className="float-right margin-top-small">
      {/* Displaying the user count */}
      <span id="users_count" className="sub-info"></span>
      <span className="sub-info">{dataUser?.usersCount} users</span>
    </div>
      <div className="float-left">
        <div className="d-flex align-items-center" style={{ flexWrap: 'nowrap' }}>
          <div className="form-group d-flex align-items-center mr-3">
            <span className="mr-2">User Status: </span>
            <FoundationsSelect
              id="select_user_status"
              value={userStatus}           
              onChange={handleStatusChange}
              name="user_status"
              containerClasses="float-left"
              errorClasses=""
              labelText=""
            >
              <option value="Registered">Registered</option>
              <option value="Confirmed">Confirmed</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
              <option value="Deleted">Deleted</option>
            </FoundationsSelect>
          </div>
          <div className="form-group d-flex align-items-center mr-3">
            <span className="mr-2">User Role: </span>
            <FoundationsSelect
              id="select_users_by_role"
              value={userRole}
              onChange={(e: { target: { value: string } }) => {
                setUserRole(e.target.value);
              }}
              name="user_role"
              containerClasses=""
              selectClasses="select-fixed-size-medium"
              errorClasses=""
              labelText=""
            >
              <option value="">- all roles -</option>
              {rolesLoading && <option>Loading roles...</option>}
              {rolesError && <option>Error loading roles...</option>}
              {isRolesArray &&
                roles.userRolesData.map((role: { Id: number; Name: string }) => (
                  <option key={role.Id} value={role.Name}>
                    {role.Name}
                  </option>
                ))}
            </FoundationsSelect>
          </div>
          <div className="form-group d-flex align-items-center mr-3">
            <span className="mr-2">Location: </span>
          <FoundationsSelect
          id="primary_site_select"
          value={userLocation} 
          onChange={(e: { target: { value: string } }) => {
            setUserLocation(e.target.value); 
            fetchUsers();
          }}
          name="user_location"
          containerClasses="float-left"
          errorClasses=""
          labelText=""
        >
         <option value="">- select a location -</option>
        {locations.map((loc, index) => (
          <option key={index} value={loc.id}>
            {loc.location}
          </option>
        ))}
        </FoundationsSelect>
          </div>
          <div className="form-group d-flex align-items-center mr-3">
            <span className="mr-2">Search: </span>
            <FoundationsSelect
              id="select_user_field"
              value={userSearch}
              onChange={(e: { target: { value: string } }) => {
                setUserSearch(e.target.value);
                setLocalSearchName("");   // clear the textbox
                setSearchName("");        // clear the actual search
                fetchUsers();             // optionally refetch users with cleared search
              }}
              name="user_search"
              containerClasses="float-left mr-3"
              errorClasses=""
              labelText=""
            >
              <option value="EmailAddress">Email Address</option>
              <option value="FirstName">First Name</option>
              <option value="LastName">Last Name</option>
              <option value="DisplayName">Display Name</option>
            </FoundationsSelect>
            <FoundationsInput
                id="admin_searchusers"
                value={localSearchName}
                onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setLocalSearchName(e.target.value);
                // If the field is cleared, also clear the searchName state and refetch
                    if (e.target.value === '') {
                      setSearchName('');
                      fetchUsers(); // Refetch when cleared
                  }
                }}
                onKeyDown={handleKeyPress}
                name="full_name_search"
                containerClasses="float-left"
                inputClasses={`field-user-edit ${highlightClass?.admin_searchusers || ''}`}
            />
            <FoundationsButton
                type="button"
                id="admin_findusers"
                buttonClasses="ui-button app-button"
                isLoading={false}
                classes="ml-1"
                onClick={handleSearch}
            >
                Find
            </FoundationsButton>
          </div>
        </div>
      </div>
      <div className="padding-bottom-medium clear-both"></div>
      {/* Dynamically render the table */}
      <table id="table_users" className="admin-table">
      {renderTableHeaders()}
       {previousDataUser && renderTableRows()}
      </table>
      {saveAttribute &&
    <Approve 
    isOpen={dialogOpen}
    userId={dialogData.userId} // Pass the userId here
    userAttributeData={userAttribute} 
    userByStatus={dataUser}
    userRole= {roles}
    saveAttribute={saveAttribute} 
    userSavedAttributes={saveAttribute} // Add this prop
    onApproveSuccess={onSuccess}  
    onClose={() => setDialogOpen(false)}
    onCommentChange={(newComment) => setApproveComment(newComment)} 
     />  
      }
      {saveAttribute &&
    <Edit
    isOpen={editdialogOpen}
    userId={dialogData.userId} // Pass the userId here
    userAttributeData={userAttribute} 
    userByStatus={dataUser}
    userRole= {roles}
    saveAttribute={saveAttribute} 
    userSavedAttributes={saveAttribute} // Add this prop
    onApproveSuccess={onSuccess}  
    onClose={() => setEditDialogOpen(false)}
     /> 
      }
    <Delete
    isOpen={deleteDialogOpen}
    userId={Number(deleteUserId)} 
    userByStatus={dataUser}
    // onDelete={() => fetchDelete({ userId: Number(deleteUserId), comment: deleteComment})} 
    onDelete={(args) => fetchDelete({ userId: Number(deleteUserId), comment: deleteComment })}
    onDeleteSuccess={onSuccess}  
    onClose={() => setDeleteDialogOpen(false)}
    onCommentChange={(newComment) => setDeleteComment(newComment)} 
    />

    <ChangePassword
    isOpen={changePasswordDialogOpen}
    userId={Number(changePasswordUserId)} 
    userByStatus={dataUser}
    onClose={() => setchangePasswordDialogOpen(false)}
     />  

     <Reject
      isOpen={rejectDialogOpen}
      userId={Number(rejectUserId)} 
      userByStatus={dataUser}
      onReject={() =>fetchReject({ userId: Number(rejectUserId), comment: rejectComment })}
      onRejectSuccess={onSuccess}
      onClose={() => setRejectDialogOpen(false)}
      onCommentChange={(newComment) => setRejectComment(newComment)} 
     />
  
    </div>
  );
};
export default ManageUserAccounts;

